/* Stage Gear — Bodymic finder v2
   One question at a time. Completed answers collapse into editable rows, and a
   compact build card carries price, strain relief, Cast Pack and add to cart.
   Resolves choices to a real Shopify variant ID; Shopify stays the source of
   truth for price, availability and images. */
(function () {
  'use strict';

  var DIM_RULES = [
    { dim: 'gen', re: /connection|connector/i },
    { dim: 'size', re: /capsule/i },
    { dim: 'boom', re: /boom/i },
    { dim: 'color', re: /colou?r/i },
    { dim: 'fit', re: /^style$/i }
  ];
  var STYLE_META = {
    earset: { label: 'Earset', sub: 'Hooks over one ear. Light, discreet and quick to fit.' },
    headset: { label: 'Headset', sub: 'Over both ears. The most secure fit for dance-heavy shows.' },
    lavalier: { label: 'Hairline / lav', sub: 'Hidden in the hairline, a wig or the costume.' }
  };
  var STYLE_ORDER = ['earset', 'headset', 'lavalier'];
  var SIZE_META = {
    '4mm': { sub: 'Discreet, and right for most live performance.', tag: 'Most popular' },
    '3mm': { sub: 'Our smallest capsule, for when hiding the mic matters most.', tag: '' }
  };
  var SWATCH = { beige: '#d8b99a', brown: '#6b4a2f', black: '#151515', tan: '#c19a6b' };
  var GEN_SUB = {
    'pre-2018': 'cW-style locking 4-pin, older UniPak packs',
    'post-2018': 'cH-style screw-down 4-pin, newer packs (e.g. 3000 Series)'
  };
  var STEP_TITLE = { system: 'your bodypack brand', style: 'style', size: 'capsule size', color: 'color', boom: 'boom length', fit: 'headset style' };
  var URL_KEY = { system: 'connection', gen: 'gen', style: 'style', size: 'size', color: 'color', boom: 'boom', fit: 'fit' };
  var LATER = ['size', 'color', 'boom', 'fit'];

  // Side-profile line icons (head in grey, mic in brand blue)
  var HEAD = '<path class="sgf-ic-head" d="M18 47V40C13 36 10.5 30 11 23.5 11.8 14 19 8 28 8c8 0 13.5 6 13.5 13l3 6.2-3 1v3.3c0 2.6-2.4 3.8-6 3.2L35 41v6" stroke-width="2" stroke-linejoin="round"/>' +
    '<path class="sgf-ic-ear" d="M25.5 20.5c-3-.2-4.5 2.2-4.2 4.8.3 2.4 2.2 3.6 4 3.4" stroke-width="1.6" stroke-linecap="round"/>';
  var MIC = '<g class="sgf-ic-mic" fill="none" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">';
  // hook goes up and over the ear; boom leaves from the front of the ear to the mouth
  var HOOK_BOOM = '<path d="M26.2 22.5C25.6 17.6 19.4 17 19.2 22.6c-.1 2.6.8 4.6 2.4 6"/><path d="M26.2 22.5c.6 5.6 5 8.8 12.6 8.8"/><circle class="sgf-ic-dot" cx="39.6" cy="31.2" r="1.9"/>';
  var ICONS = {
    earset: '<svg viewBox="0 0 52 52" aria-hidden="true">' + HEAD + MIC + HOOK_BOOM + '</g></svg>',
    // band wraps around the back of the head, behind the ear
    headset: '<svg viewBox="0 0 52 52" aria-hidden="true">' + HEAD + MIC + '<path d="M20.4 27.2c-3.6 1-8 2.4-11 4.6"/>' + HOOK_BOOM + '</g></svg>',
    // capsule at the hairline, cable follows the skull down behind the ear
    lavalier: '<svg viewBox="0 0 52 52" aria-hidden="true">' + HEAD + MIC + '<path d="M35.6 11.9C33.3 11 30.7 10.6 28 10.6c-7.6 0-13.6 5.2-14.3 13.1-.4 5.2 1.4 9.6 5.1 13"/><circle class="sgf-ic-dot" cx="35.6" cy="11.9" r="2.1"/></g></svg>'
  };

  function slug(v) {
    return String(v == null ? '' : v).split(' — ')[0].split(' - ')[0].toLowerCase().replace(/["”]/g, '').replace(/\s+/g, '').replace(/[^a-z0-9.\-]/g, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function track(name, data) {
    data = Object.assign({ configurator: 'bodymics', finder_version: 'v2' }, data || {});
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
  }
  function firstPart(label) { return String(label).split(/\s+[—-]\s+/)[0]; }

  function Finder(root) {
    this.root = root;
    var raw = root.querySelector('[data-sgbc-data]');
    var data;
    try { data = JSON.parse(raw.textContent); } catch (e) { console.error('[sgf] bad data', e); return; }
    this.systems = data.systems || [];
    this.products = (data.products || []).map(this.normalizeProduct.bind(this));
    this.sel = {};
    this.openStep = null;   // step the shopper reopened with "Change"
    this.started = false;
    this.q = function (s) { return root.querySelector(s); };
    this.bind();
    this.initFromUrl();
    this.render();
    this.syncCart();
  }
  var P = Finder.prototype;

  // Paid Bodymics already in the cart, by style + price (Cast Pack counts per style + price)
  P.syncCart = function () {
    var self = this;
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = 0, bp = {};
        (c.items || []).forEach(function (it) {
          if (it.product_type === 'Bodymics' && !(it.properties && it.properties._castpack === 'free')) { var sm = /earset|headset|lavalier/i.exec(it.product_title || ''), k = (sm ? sm[0].toLowerCase() : 'other') + '|' + it.price; n += it.quantity; bp[k] = (bp[k] || 0) + it.quantity; }
        });
        self.cartPaid = n; self.cartByPrice = bp; self.render();
      }).catch(function () {});
  };

  P.normalizeProduct = function (p) {
    var dims = [];
    (p.options || []).forEach(function (name, i) {
      var d = null;
      for (var k = 0; k < DIM_RULES.length; k++) if (DIM_RULES[k].re.test(name)) { d = DIM_RULES[k].dim; break; }
      dims.push({ dim: d || ('opt' + i), name: name, index: i });
    });
    var variants = p.variants.map(function (v) {
      var vals = {}, labels = {};
      dims.forEach(function (d) { vals[d.dim] = slug(v.o[d.index]); labels[d.dim] = v.o[d.index]; });
      return { id: v.id, sku: v.sku, vals: vals, labels: labels, price: v.price, available: v.available, img: v.img, alt: v.alt };
    });
    // No capsule option? Derive it from the SKU prefix: B = 4 mm, D = 3 mm.
    if (!dims.some(function (d) { return d.dim === 'size'; })) {
      var known = {};
      variants.forEach(function (v) {
        var s = String(v.sku || '').trim().charAt(0).toUpperCase();
        v.skuSize = s === 'B' ? '4mm' : (s === 'D' ? '3mm' : null);
        if (v.skuSize) known[v.skuSize] = 1;
      });
      var ks = Object.keys(known);
      if (ks.length) {
        variants.forEach(function (v) {
          var val = v.skuSize || (ks.length === 1 ? ks[0] : null);
          if (val) { v.vals.size = val; v.labels.size = val === '4mm' ? '4 mm' : '3 mm'; }
        });
        dims.push({ dim: 'size', name: 'Capsule', index: -1, derived: true });
      }
    }
    return { system: p.system, style: p.style, compat: p.compat, connector: p.connector, id: p.id, title: p.title, url: p.url, img: p.img, dims: dims, dimSet: dims.map(function (d) { return d.dim; }), variants: variants };
  };

  /* ---------- data helpers ---------- */
  P.productsFor = function (system, style) {
    return this.products.filter(function (p) { return (!system || p.system === system) && (!style || p.style === style); });
  };
  P.currentProduct = function () {
    if (!this.sel.system || !this.sel.style) return null;
    return this.productsFor(this.sel.system, this.sel.style)[0] || null;
  };
  P.genValues = function () {
    var seen = {}, out = [];
    this.productsFor(this.sel.system).forEach(function (p) {
      if (p.dimSet.indexOf('gen') === -1) return;
      p.variants.forEach(function (v) { if (!seen[v.vals.gen]) { seen[v.vals.gen] = 1; out.push({ val: v.vals.gen, label: v.labels.gen }); } });
    });
    return out;
  };
  P.needsGen = function () { return this.genValues().length > 0; };
  P.match = function (p, dims) {
    var sel = this.sel;
    return p.variants.filter(function (v) {
      for (var i = 0; i < dims.length; i++) {
        var d = dims[i];
        if (p.dimSet.indexOf(d) === -1) continue;
        if (sel[d] && v.vals[d] !== sel[d]) return false;
      }
      return true;
    });
  };
  P.systemReady = function () { return !!this.sel.system && (!this.needsGen() || !!this.sel.gen); };
  P.stepOrder = function () {
    var p = this.currentProduct();
    var steps = ['system', 'style'];
    if (!p) return steps.concat(['size', 'color']);
    LATER.forEach(function (d) { if (p.dimSet.indexOf(d) > -1) steps.push(d); });
    return steps;
  };
  P.isDone = function (s) { return s === 'system' ? this.systemReady() : !!this.sel[s]; };
  P.firstOpen = function () {
    var self = this;
    return this.stepOrder().filter(function (s) { return !self.isDone(s); })[0] || null;
  };
  P.isComplete = function () {
    var p = this.currentProduct();
    if (!p || !this.systemReady()) return false;
    var sel = this.sel;
    return p.dimSet.every(function (d) { return d.indexOf('opt') === 0 ? true : !!sel[d]; });
  };
  P.resolved = function () {
    var p = this.currentProduct();
    if (!p || !this.isComplete()) return null;
    var m = this.match(p, p.dimSet);
    return m.length === 1 ? m[0] : null;
  };
  P.labelFor = function (d) {
    var p = this.currentProduct(), sel = this.sel;
    if (!p || !sel[d]) return null;
    var v = p.variants.filter(function (x) { return x.vals[d] === sel[d]; })[0];
    return v ? v.labels[d] : null;
  };

  /* ---------- state changes ---------- */
  P.choose = function (dim, val) {
    this.justAdded = false;
    if (!this.started) { this.started = true; track('configurator_started'); }
    this.sel[dim] = val;
    if (dim === 'system') {
      delete this.sel.gen;
      if (!this.productsFor(val, this.sel.style)[0]) delete this.sel.style;
    }
    this.prune();
    this.openStep = null;
    var evt = { system: 'connection_selected', gen: 'connection_selected', style: 'style_selected', size: 'size_selected', color: 'color_selected', boom: 'boom_selected', fit: 'style_selected' }[dim];
    if (evt) track(evt, { value: val });
    this.render();
    this.writeUrl();
    if (this.isComplete()) {
      var v = this.resolved();
      if (v) track('bodymic_configuration_completed', { variant_id: v.id, configuration: this.summaryText() });
    }
  };
  P.prune = function () {
    var p = this.currentProduct(), sel = this.sel;
    if (sel.gen && !this.genValues().some(function (g) { return g.val === sel.gen; })) delete sel.gen;
    if (!p) return;
    LATER.forEach(function (d) {
      if (!sel[d]) return;
      if (p.dimSet.indexOf(d) === -1 || !p.variants.some(function (v) { return v.vals[d] === sel[d]; })) delete sel[d];
    });
    // auto-answer any question with only one possible answer
    LATER.forEach(function (d) {
      if (sel[d] || p.dimSet.indexOf(d) === -1) return;
      var vs = {}; p.variants.forEach(function (v) { if (v.vals[d]) vs[v.vals[d]] = 1; });
      var keys = Object.keys(vs);
      if (keys.length === 1) sel[d] = keys[0];
    });
  };

  /* ---------- rendering ---------- */
  P.opt = function (dim, val, inner, o) {
    o = o || {};
    return '<button type="button" class="sgf-opt' + (o.cls ? ' ' + o.cls : '') + '" role="radio" aria-checked="' + (this.sel[dim] === val) + '" data-dim="' + dim + '" data-val="' + esc(val) + '"' +
      (o.disabled ? ' disabled' : '') + ' aria-label="' + esc(o.aria || '') + '">' + inner + '</button>';
  };

  P.renderOptions = function (s, p) {
    var self = this, sel = this.sel, q = this.q;
    if (s === 'system') {
      q('[data-opts="system"]').innerHTML = this.systems.map(function (sy) {
        var any = self.productsFor(sy.key).some(function (pp) { return pp.variants.some(function (v) { return v.available; }); });
        return self.opt('system', sy.key, '<b>' + esc(sy.label) + '</b>' + (sy.connector ? '<span>' + esc(sy.connector) + '</span>' : '') +
          (sy.note ? '<em>' + esc(sy.note) + '</em>' : '') + (any ? '' : '<span class="sgf-oos">Currently out of stock</span>'), { aria: sy.label });
      }).join('');
      var gens = sel.system ? this.genValues() : [];
      q('[data-gen-wrap]').hidden = !gens.length;
      q('[data-opts="gen"]').innerHTML = gens.map(function (g) {
        return self.opt('gen', g.val, '<b>' + esc(g.label) + '</b>' + (GEN_SUB[g.val] ? '<span>' + esc(GEN_SUB[g.val]) + '</span>' : ''), { aria: 'Audio-Technica ' + g.label });
      }).join('');
      return;
    }
    if (s === 'style') {
      q('[data-opts="style"]').innerHTML = STYLE_ORDER.filter(function (st) { return self.productsFor(sel.system, st).length; }).map(function (st) {
        var pp = self.productsFor(sel.system, st)[0];
        var vs = self.match(pp, ['gen']);
        var min = Math.min.apply(null, vs.map(function (v) { return v.price; }));
        var oos = !vs.some(function (v) { return v.available; });
        var m = STYLE_META[st];
        return self.opt('style', st, ICONS[st] + '<div><b>' + m.label + '</b><span>' + m.sub + '</span><em>From ' + money(min) + '</em>' +
          (oos ? '<span class="sgf-oos">Out of stock</span>' : '') + '</div>', { cls: 'sgf-opt--style', aria: m.label + (oos ? ', out of stock' : '') });
      }).join('');
      return;
    }
    // later steps: size / color / boom / fit
    var box = q('[data-opts="' + s + '"]');
    if (!p) { box.innerHTML = ''; return; }
    var before = ['gen'].concat(LATER.slice(0, LATER.indexOf(s)));
    var seen = {}, vals = [];
    p.variants.forEach(function (v) { if (v.vals[s] && !seen[v.vals[s]]) { seen[v.vals[s]] = 1; vals.push({ val: v.vals[s], label: v.labels[s] }); } });
    if (s === 'boom') {
      vals.sort(function (a, b) { return (parseFloat(a.label) || 99) - (parseFloat(b.label) || 99); });
    }
    var maxBoom = Math.max.apply(null, vals.map(function (o) { return parseFloat(o.label) || 0; }).concat([1]));
    box.innerHTML = vals.map(function (o) {
      var vs = self.match(p, before).filter(function (v) { return v.vals[s] === o.val; });
      var exists = vs.length > 0, avail = vs.some(function (v) { return v.available; });
      var parts = String(o.label).split(/\s+[—-]\s+/), inner = '', cls = '';
      if (s === 'color') {
        cls = 'sgf-opt--color';
        inner = '<span class="sgf-sw" style="background:' + (SWATCH[o.val] || '#ccc') + '" aria-hidden="true"></span><b>' + esc(o.label) + '</b>';
      } else if (s === 'size') {
        var px = o.val === '3mm' ? 9 : 13, sm = SIZE_META[o.val] || {};
        var min = vs.length ? Math.min.apply(null, vs.map(function (v) { return v.price; })) : null;
        inner = (sm.tag ? '<span class="sgf-tag">' + sm.tag + '</span>' : '') + '<span class="sgf-dot" aria-hidden="true"><i style="width:' + px + 'px;height:' + px + 'px"></i></span><b>' + esc(o.label) + '</b>' + (sm.sub ? '<span>' + sm.sub + '</span>' : '') + (min != null ? '<em>' + money(min) + '</em>' : '');
      } else if (s === 'boom') {
        var len = parseFloat(o.label);
        var bar = isNaN(len) ? '<span class="sgf-boom sgf-boom--var" aria-hidden="true"><i style="width:100%"></i></span>' : '<span class="sgf-boom" aria-hidden="true"><i style="width:' + Math.round(len / maxBoom * 100) + '%"></i></span>';
        inner = (/standard/i.test(o.label) ? '<span class="sgf-tag">Most common</span>' : '') + '<b>' + esc(parts[0]) + '</b>' + bar + (parts[1] ? '<span>' + esc(parts.slice(1).join(' — ')) + '</span>' : (isNaN(len) ? '<span>Adjustable</span>' : ''));
      } else if (s === 'fit') {
        var fs = { standard: 'Fixed ear hooks', 'fold-flat': 'Ear hooks fold flat for storage' }[o.val] || '';
        inner = '<b>' + esc(o.label) + '</b>' + (fs ? '<span>' + fs + '</span>' : '');
      }
      if (exists && !avail) inner += '<span class="sgf-oos">Out of stock</span>';
      return self.opt(s, o.val, inner, { cls: cls, aria: o.label + (exists && !avail ? ', out of stock' : ''), disabled: !exists });
    }).join('');
  };

  P.valueText = function (s) {
    var sel = this.sel;
    if (s === 'system') {
      var sy = this.systems.filter(function (x) { return x.key === sel.system; })[0];
      if (!sy) return '';
      var g = sel.gen ? this.genValues().filter(function (x) { return x.val === sel.gen; })[0] : null;
      return sy.label + (g ? ' · ' + g.label : (sy.connector && !this.needsGen() ? ' · ' + sy.connector : ''));
    }
    if (s === 'style') return sel.style ? STYLE_META[sel.style].label : '';
    var l = this.labelFor(s);
    if (!l) return '';
    return s === 'boom' ? String(l).replace(/\s+[—-]\s+/, ' · ') : l;
  };

  P.render = function () {
    var self = this, q = this.q;
    var p = this.currentProduct();
    var order = this.stepOrder();
    var current = this.openStep === '__none__' ? null : (this.openStep && order.indexOf(this.openStep) > -1 ? this.openStep : this.firstOpen());
    var reachable = true;
    var n = 0;
    ['system', 'style', 'size', 'color', 'boom', 'fit'].forEach(function (s) {
      var el = q('[data-step="' + s + '"]');
      var inOrder = order.indexOf(s) > -1;
      el.hidden = !inOrder;
      if (!inOrder) return;
      n++;
      el.querySelector('.sgf-num span').textContent = n;
      var done = self.isDone(s);
      var state = s === current ? 'open' : (done ? 'done' : 'todo');
      el.setAttribute('data-state', state);
      var head = el.querySelector('.sgf-head');
      head.setAttribute('aria-expanded', String(state === 'open'));
      head.disabled = !reachable && state !== 'open';
      el.querySelector('[data-val]').textContent = state === 'open' ? '' : self.valueText(s);
      el.querySelector('.sgf-body').hidden = state !== 'open';
      if (state === 'open') self.renderOptions(s, p);
      if (!done) reachable = false;
    });
    this.renderCard(p);
  };

  P.renderCard = function (p) {
    var q = this.q, sel = this.sel;
    var v = this.resolved();
    // thumbnail + name
    var thumb = q('[data-thumb]');
    var pv = null;
    if (p) { var mv = this.match(p, p.dimSet); pv = (v || mv[0] || p.variants[0]); }
    var src = pv ? (pv.img || p.img) : null;
    if (src) {
      var img = thumb.querySelector('img');
      if (!img) { thumb.innerHTML = '<img alt="" width="72" height="72" loading="lazy">'; img = thumb.querySelector('img'); }
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.alt = pv.alt || p.title;
    } else {
      thumb.innerHTML = ICONS[sel.style || 'earset'];
    }
    var sy = this.systems.filter(function (x) { return x.key === sel.system; })[0];
    var name = q('[data-name]');
    if (v) name.innerHTML = '<a href="' + esc(p.url + '?variant=' + v.id) + '">' + esc((sy ? sy.label + ' ' : '') + STYLE_META[sel.style].label) + '</a>';
    else if (sy && sel.style) name.textContent = sy.label + ' ' + STYLE_META[sel.style].label;
    else if (sy) name.textContent = sy.label + ' Bodymic';
    else name.textContent = 'Start with your bodypack brand';
    var spec = [];
    var self = this;
    ['size', 'color', 'boom', 'fit'].forEach(function (d) { var l = self.labelFor(d); if (l) spec.push(d === 'boom' ? firstPart(l) + ' boom' : firstPart(l)); });
    if (sel.gen) spec.unshift(this.valueText('system').split(' · ')[1]);
    q('[data-spec]').textContent = spec.join(' · ');

    // price + stock
    var priceEl = q('[data-price]'), stock = q('[data-stock]');
    var sr = this.srOn(), srp = this.srPrice();
    if (v) {
      priceEl.innerHTML = money(v.price + (sr ? srp : 0)) + (this.qty() > 1 || sr ? '<span>per mic' + (sr ? ', incl. strain relief' : '') + '</span>' : '');
      stock.textContent = v.available ? 'In stock' : 'Out of stock';
      stock.setAttribute('data-ok', String(!!v.available));
      stock.hidden = false;
    } else {
      var pool = p ? this.match(p, p.dimSet) : [];
      if (!pool.length) this.productsFor(sel.system, sel.style).forEach(function (pp) { pool = pool.concat(pp.variants); });
      var min = pool.length ? Math.min.apply(null, pool.map(function (x) { return x.price; })) : null;
      priceEl.innerHTML = min != null ? '<small>From</small>' + money(min) : '';
      stock.hidden = true;
    }
    // compat
    var cp = q('[data-compat]');
    if (v) {
      var conn = p.connector || '';
      if (sel.gen === 'pre-2018') conn = 'cW-style Hirose 4-pin';
      if (sel.gen === 'post-2018') conn = 'cH-style screw-down 4-pin';
      var ct = ((p.compat || '') + (conn ? ' Connector: ' + conn + '.' : '')).trim();
      cp.hidden = !ct; cp.querySelector('span').textContent = ct;
    } else cp.hidden = true;

    // strain relief
    var srx = q('[data-srx]');
    if (!this.srInit) { this.srInit = true; try { this.srBox().checked = sessionStorage.getItem('sgbmSR') === '1'; } catch (e) {} }
    srx.hidden = !this.srAllowed();

    // main button
    var add = q('[data-add]'), qty = this.qty();
    var next = this.firstOpen();
    if (v) {
      add.setAttribute('data-mode', 'add');
      add.disabled = !v.available;
      add.textContent = v.available ? (qty > 1 ? 'Add ' + qty + ' to cart' : 'Add to cart') : 'Out of stock';
    } else {
      add.setAttribute('data-mode', 'next');
      add.disabled = false;
      add.textContent = next ? 'Next: choose ' + STEP_TITLE[next] : 'Choose your options';
    }
    // total breakdown (only when it adds information)
    var tot = q('[data-total]');
    if (v && (qty > 1 || sr)) {
      tot.innerHTML = qty + ' × ' + (sr ? '(' + money(v.price) + ' mic + ' + money(srp) + ' strain relief)' : money(v.price)) + ' = <b>' + money((v.price + (sr ? srp : 0)) * qty) + '</b>';
      tot.hidden = false;
    } else tot.hidden = true;

    // Cast Pack meter: one buy-4-get-1 per style + price, so count cart mics of this style and price (+ this qty unless just added)
    var cpKey = v ? sel.style + '|' + v.price : null;
    var cpN = cpKey && this.cartByPrice ? (this.cartByPrice[cpKey] || 0) : 0;
    var tq = this.justAdded ? cpN : cpN + qty;
    var free = Math.min(Math.floor(tq / 4), 4);
    var inSet = tq % 4, full = tq >= 16 || (tq >= 4 && inSet === 0), pips = '';
    for (var i = 0; i < 4; i++) pips += '<i data-on="' + (full || i < inSet ? 'paid' : '') + '"></i>';
    pips += '<i data-on="' + (full ? 'free' : '') + '"></i>';
    q('[data-pips]').innerHTML = pips;
    var txt;
    if (free === 0) txt = 'Add ' + (4 - tq) + ' more and we add a 5th mic free.';
    else if (free >= 4) txt = 'You get ' + free + ' free mics (' + (tq + free) + ' total). That is the Cast Pack maximum.';
    else txt = 'We add ' + free + ' free mic' + (free > 1 ? 's' : '') + ' to your cart automatically' + (sr ? ', with strain relief at ' + money(srp) + ' each' : '') + '. ' + (inSet ? 'Add ' + (4 - inSet) + ' more for another.' : '');
    if (cpN) txt = 'Your cart has ' + cpN + ' ' + money(v.price).replace('.00', '') + ' ' + sel.style + (cpN > 1 ? 's' : '') + (this.justAdded ? '' : ', plus ' + qty + ' here') + '. ' + txt;
    q('[data-cp-text]').textContent = txt.trim();

    q('[data-quote]').href = '/pages/request-a-quote?product=' + encodeURIComponent('Bodymics: ' + (this.summaryText() || 'not chosen yet') + ' (qty ' + qty + ')');
    this.renderBar(v, next);
  };

  /* ---------- strain relief (earsets + headsets) ---------- */
  P.srAllowed = function () { return this.sel.style === 'earset' || this.sel.style === 'headset'; };
  P.srBox = function () { return this.root.querySelector('[data-sr-toggle]'); };
  P.srPrice = function () { var b = this.srBox(); return b ? (parseInt(b.getAttribute('data-sr-price'), 10) || 1000) : 1000; };
  P.srOn = function () { var b = this.srBox(); return !!(b && b.checked && this.srAllowed()); };

  P.summaryText = function () {
    var parts = [], self = this;
    var sv = this.valueText('system'); if (sv) parts.push(sv.split(' · ')[0]);
    if (this.sel.gen) parts.push(sv.split(' · ')[1]);
    ['size', 'color'].forEach(function (d) { var l = self.labelFor(d); if (l) parts.push(firstPart(l)); });
    if (this.sel.style) parts.push(STYLE_META[this.sel.style].label);
    var b = this.labelFor('boom'); if (b) parts.push(firstPart(b) + ' boom');
    var f = this.labelFor('fit'); if (f) parts.push(f);
    return parts.join(' • ');
  };
  P.qty = function () {
    var n = parseInt(this.q('[data-q]').value, 10);
    return isNaN(n) || n < 1 ? 1 : Math.min(n, 200);
  };

  P.renderBar = function (v, next) {
    var bar = this.q('[data-bar]');
    if (!bar) return;
    var sr = this.srOn();
    bar.querySelector('[data-bar-price]').textContent = v ? money((v.price + (sr ? this.srPrice() : 0)) * this.qty()) : (this.q('[data-price]').textContent.replace(/^From/, 'From ') || 'Bodymic finder');
    bar.querySelector('[data-bar-sum]').textContent = v ? this.qty() + ' × ' + this.summaryText() : (next ? 'Next: ' + STEP_TITLE[next] : '');
    var b = bar.querySelector('[data-bar-add]');
    b.disabled = !!v && !v.available;
    b.textContent = v ? (v.available ? 'Add to cart' : 'Out of stock') : 'Continue';
    this.updateBar();
  };
  P.updateBar = function () {
    var bar = this.q('[data-bar]');
    if (!bar) return;
    var show = this.started && this.inView && !this.cardVisible;
    bar.setAttribute('data-show', String(!!show));
    bar.setAttribute('aria-hidden', String(!show));
    bar.querySelector('[data-bar-add]').tabIndex = show ? 0 : -1;
  };

  /* ---------- URL state ---------- */
  P.writeUrl = function () {
    try {
      var url = new URL(window.location.href), sel = this.sel;
      Object.keys(URL_KEY).forEach(function (k) { url.searchParams.delete(URL_KEY[k]); });
      ['system', 'gen', 'style', 'size', 'color', 'boom', 'fit'].forEach(function (k) { if (sel[k]) url.searchParams.set(URL_KEY[k], sel[k]); });
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    } catch (e) {}
  };
  P.initFromUrl = function () {
    var params;
    try { params = new URL(window.location.href).searchParams; } catch (e) { return; }
    var self = this;
    var sysParam = slug(params.get('connection') || '');
    var st = slug(params.get('style'));
    if (st === 'lav' || st === 'hairline') st = 'lavalier';
    if (!(sysParam && this.systems.some(function (s) { return s.key === sysParam; }))) {
      if (st && this.productsFor(null, st).length) this.sel.style = st;
      return;
    }
    this.sel.system = sysParam;
    var gen = slug(params.get('gen'));
    if (gen && this.genValues().some(function (g) { return g.val === gen; })) this.sel.gen = gen;
    if (st && this.productsFor(this.sel.system, st).length) this.sel.style = st;
    var p = this.currentProduct();
    if (p) {
      LATER.forEach(function (d) {
        var val = slug(params.get(URL_KEY[d]));
        if (!val) return;
        if (d === 'size' && /^[34]$/.test(val)) val += 'mm';
        if (p.variants.some(function (v) { return v.vals[d] === val; })) self.sel[d] = val;
      });
    }
    this.prune();
    this.started = true;
  };

  /* ---------- events ---------- */
  P.goTo = function (step, focusFirst) {
    var el = step ? this.q('[data-step="' + step + '"]') : this.q('[data-card]');
    if (!el) return;
    var r = el.getBoundingClientRect();
    if (r.top < 70 || r.top > window.innerHeight - 160) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: window.pageYOffset + r.top - 110, behavior: reduce ? 'auto' : 'smooth' });
    }
    if (focusFirst) {
      var f = step ? (el.querySelector('.sgf-opt[aria-checked="true"]') || el.querySelector('.sgf-opt:not([disabled])')) : this.q('[data-add]');
      if (f) f.focus({ preventScroll: true });
    }
  };
  P.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.sgf-opt');
      if (opt && !opt.disabled) {
        var dim = opt.getAttribute('data-dim');
        self.choose(dim, opt.getAttribute('data-val'));
        var nx = self.firstOpen();
        // keep the system step open while the Audio-Technica connector is unanswered
        self.goTo(nx, true);
        return;
      }
      var head = e.target.closest('.sgf-head');
      if (head && !head.disabled) {
        var s = head.getAttribute('data-head');
        var open = head.getAttribute('aria-expanded') === 'true';
        self.openStep = open ? '__none__' : s;
        self.render();
        if (!open) self.goTo(s, false);
        return;
      }
      var qb = e.target.closest('[data-qty]');
      if (qb) {
        self.justAdded = false;
        var inp = self.q('[data-q]');
        inp.value = Math.max(1, Math.min(200, self.qty() + parseInt(qb.getAttribute('data-qty'), 10)));
        self.render();
        return;
      }
      // "Add a different mic": keep the wireless system, clear the mic, go back to style
      if (e.target.closest('[data-more]')) {
        track('bodymic_add_another', { in_cart: self.cartPaid || 0 });
        var keep = { system: self.sel.system, gen: self.sel.gen };
        self.sel = {};
        if (keep.system) self.sel.system = keep.system;
        if (keep.gen) self.sel.gen = keep.gen;
        self.q('[data-q]').value = 1;
        self.justAdded = false; self.openStep = null;
        var m = self.q('[data-msg]'); m.innerHTML = ''; m.removeAttribute('data-type');
        self.render(); self.writeUrl(); self.goTo(self.firstOpen(), true);
        return;
      }
      var add = e.target.closest('[data-add]') || e.target.closest('[data-bar-add]');
      if (add) {
        if (self.resolved()) self.addToCart(add);
        else { self.openStep = null; self.render(); self.goTo(self.firstOpen(), true); }
        return;
      }
      if (e.target.closest('[data-reset]')) {
        self.sel = {}; self.openStep = null; self.render(); self.writeUrl();
        self.goTo('system', true);
        return;
      }
      var cb = e.target.closest('[data-copy]');
      if (cb) {
        var done = function () { cb.textContent = 'Link copied'; setTimeout(function () { cb.textContent = 'Copy link'; }, 2000); };
        try { navigator.clipboard.writeText(window.location.href).then(done, function () {}); } catch (err) {}
      }
    });
    root.addEventListener('keydown', function (e) {
      var opt = e.target.closest && e.target.closest('.sgf-opt');
      if (!opt) return;
      var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      if (!(e.key in keys)) return;
      var group = Array.prototype.slice.call(opt.parentNode.querySelectorAll('.sgf-opt:not([disabled])'));
      var nx = group[(group.indexOf(opt) + keys[e.key] + group.length) % group.length];
      if (nx) { e.preventDefault(); nx.focus(); }
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-q]')) { self.justAdded = false; e.target.value = self.qty(); self.render(); }
      if (e.target.matches('[data-sr-toggle]')) {
        try { sessionStorage.setItem('sgbmSR', e.target.checked ? '1' : '0'); } catch (err) {}
        track('bodymic_strain_relief_toggled', { on: e.target.checked });
        self.render();
      }
    });
    root.addEventListener('input', function (e) { if (e.target.matches('[data-q]') && e.target.value !== '') { self.justAdded = false; self.render(); } });
    if ('IntersectionObserver' in window) {
      var card = root.querySelector('[data-card]'), app = root.querySelector('[data-app]');
      new IntersectionObserver(function (en) { self.cardVisible = en[0].isIntersecting; self.updateBar(); }, { rootMargin: '0px 0px -80px 0px' }).observe(card);
      new IntersectionObserver(function (en) { self.inView = en[0].isIntersecting; self.updateBar(); }).observe(app);
    }
    window.addEventListener('popstate', function () { self.sel = {}; self.openStep = null; self.initFromUrl(); self.render(); });
  };

  P.addToCart = function (btn) {
    var self = this, v = this.resolved(), msg = this.q('[data-msg]');
    if (!v || !v.available) return;
    var qty = this.qty(), sr = this.srOn();
    var cart = document.querySelector('cart-sidebar');
    var sections = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    msg.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [sr ? { id: v.id, quantity: qty, properties: { 'Strain relief': 'Added' } } : { id: v.id, quantity: qty }], sections: sections, sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          msg.setAttribute('data-type', 'error');
          msg.textContent = (res.j && (res.j.description || res.j.message)) || 'Sorry, we could not add that to your cart.';
          return;
        }
        track('bodymic_added_to_cart', { variant_id: v.id, quantity: qty, configuration: self.summaryText(), price: v.price / 100, strain_relief: sr });
        msg.setAttribute('data-type', 'ok');
        self.justAdded = true;
        self.cartPaid = (self.cartPaid || 0) + qty;
        self.cartByPrice = self.cartByPrice || {};
        var ck = self.sel.style + '|' + v.price;
        self.cartByPrice[ck] = (self.cartByPrice[ck] || 0) + qty;
        msg.innerHTML = '<span class="sgf-ok-t">Added ' + qty + ' × ' + esc(self.summaryText()) + (sr ? ' with strain relief' : '') + '</span>' +
          '<span class="sgf-ok-a"><button type="button" class="sgf-more" data-more>+ Add a different mic</button><a href="/cart">View cart</a></span>';
        self.syncCart();
        if (cart && res.j.sections && cart.renderContents) { try { cart.renderContents(res.j); } catch (e) {} }
      })
      .catch(function () {
        msg.setAttribute('data-type', 'error');
        msg.textContent = 'Something went wrong. Please try again or call 718-874-2642.';
      })
      .finally(function () { btn.disabled = false; btn.textContent = label; self.render(); });
  };

  function init() {
    if (!document.getElementById('sgf-more-css')) { var st = document.createElement('style'); st.id = 'sgf-more-css'; st.textContent = ".sgf-msg[data-type=ok]{display:flex;flex-direction:column;gap:10px;margin:0;padding:12px 14px;border-radius:10px;background:#E8F5EE;color:#127A4A}.sgf-ok-t:before{content:\"\\2713\\00a0\"}.sgf-ok-a{display:flex;flex-wrap:wrap;align-items:center;gap:8px 16px}.sgf-more{height:42px;padding:0 16px;border-radius:10px;border:1.5px solid #1F4B99;background:#fff;color:#1F4B99;font:inherit;font-weight:700;cursor:pointer}.sgf-more:hover{background:#EEF2FA}.sgf-more:focus-visible{outline:3px solid #f2c14e;outline-offset:2px}.sgf-ok-a a{color:#1F4B99!important;font-weight:700}"; document.head.appendChild(st); }
    document.querySelectorAll('.sgf[data-section]').forEach(function (el) { if (!el.__sgf) el.__sgf = new Finder(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
